var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-container"},[_c('div',{staticClass:"chart-scroll-wrapper"},[_c('canvas',{ref:"chartCanvas",staticClass:"chart-canvas"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }